var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cityCascaderBox"},[_c('el-cascader',{attrs:{"placeholder":"请选择","clearable":"","options":_vm.data,"props":_vm.props,"disabled":_vm.disabled,"show-all-levels":_vm.showAllLevels},on:{"change":_vm.Change},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }